import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreatePlantillaEscritoRequest } from '@models/plantillaEscrito/createPlantillaEscritoRequest.model';
import { PlantillaEscritoDto } from '@models/plantillaEscrito/planillaEscritoDto.model';
import { UpdatePlantillaEscritoRequest } from '@models/plantillaEscrito/updatePlantillaEscritoRequest.model';
import { PlantillaEscritoService } from '@services/plantillaEscrito/plantillaEscrito.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoEscritoService } from '@services/tipoEscrito/tipoEscrito.service';
import { EditorComponent, EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { isFalsy } from 'utility-types';

const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
const isSmallScreen = window.matchMedia('(max-width: 1023.5px)').matches;

@Component({
  selector: 'app-plantilla-escrito',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    MatCardModule,
    MatSnackBarModule,
    MatDividerModule,
    ButtonCloseDialogComponent,
    NgxSpinnerModule,
    ButtonCancelDialogComponent,
    ButtonAddComponent,
    EditorComponent,
    ButtonSaveComponent,
  ],
  templateUrl: 'plantilla-escrito.component.html',
  styleUrl: './plantilla-escrito.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,

})
export class PlantillaEscritoComponent {
  init: EditorComponent['init'] = {
    plugins: [
      // Core editing features
      'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', 'fullscreen', 'accordion', 'autosave', 'save',
      // Your account includes a free trial of TinyMCE premium features
      // Try the most popular premium features until Apr 25, 2025:
      // 'checklist', 'mediaembed', 'casechange', 'formatpainter', 'pageembed', 'a11ychecker', 'tinymcespellchecker', 'permanentpen', 'powerpaste', 'advtable', 'advcode', 'editimage', 'advtemplate','mentions', 'tinycomments', 'tableofcontents', 'footnotes', 'mergetags', 'autocorrect', 'typography', 'inlinecss', 'markdown','importword', 'exportword', 'exportpdf',
    ],
    toolbar: 'fullscreen restoredraft save| undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | accordion ',
    tinycomments_mode: 'embedded',
    tinycomments_author: 'Author name',
    selector: 'textarea',
    language: 'es',
    toolbar_mode: 'sliding',
    contextmenu: 'link image table',
    skin: useDarkMode ? 'oxide-dark' : 'oxide',
    content_css: useDarkMode ? 'dark' : 'default',
    mergetags_list: [
      { value: 'First.Name', title: 'First Name' },
      { value: 'Email', title: 'Email' },
    ],
  };
  sidebarVisible = true;
  plantillaForm: FormGroup;
  plantillas: PlantillaEscritoDto[] = [];
  @Input() plantillaEdit: any = null; // Si estás editando, pasás el objeto acá

  idSeleccionado: number | null = null;
  filtro = '';
  tipoFiltro: number | null = null;
  dataSource: any;
  tiposEscrito!: BaseDto[];
  AccionesDialog = AccionesDialog;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PlantillaEscritoComponent>,
    private plantillaEscritoService: PlantillaEscritoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog,
    private tipoEscritoService: TipoEscritoService
  ) {


    this.plantillaForm = this.fb.group({
      Titulo: [''],
      Descripcion: [''],
      Observaciones: [''],
      CuerpoHTML: [''],
      IdTipoEscrito: [null],
      IdUsuario: [1]
    });



  }

  ngOnInit() {

    this.getAllTipoEscrito();

    if (this.data.accion === AccionesDialog.Modificar && this.data.entidad) {
      this.completaFormulario();
    }

  }
  completaFormulario() {
    this.plantillaForm.controls['Titulo'].setValue(this.data.entidad.Titulo)

    this.plantillaForm.controls['Descripcion'].setValue(isFalsy(this.data.entidad.Descripcion) ? "" : this.data.entidad.Descripcion)

    this.plantillaForm.controls['Observaciones'].setValue(isFalsy(this.data.entidad.Observaciones) ? "" : this.data.entidad.Observaciones)

    this.plantillaForm.controls['CuerpoHTML'].setValue(isFalsy(this.data.entidad.CuerpoHTML) ? "" : this.data.entidad.CuerpoHTML)

    this.plantillaForm.controls['IdTipoEscrito'].setValue(isFalsy(this.data.entidad.IdTipoEscrito) ? "" : this.data.entidad.IdTipoEscrito)

    this.plantillaForm.controls['IdUsuario'].setValue(isFalsy(this.data.entidad.IdUsuario) ? "" : this.data.entidad.IdUsuario)

  }
  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }
  onGuardarBorrador() {

  }

  onCrear() {
    const createPlantillaEscritoRequest = this.plantillaForm.value as CreatePlantillaEscritoRequest;
    this.plantillaEscritoService.create(createPlantillaEscritoRequest).subscribe(
      data => {
        this.spinner.hide('spListado')
        this.snackBar.showSuccess('Plantilla creada.', "Exito");
        this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.entidad });
      },
      error => {
        this.spinner.hide('spListado')
        this.snackBar.showError(error, "Error");
      }
    );
  }

  onGuardar() {
    const updatePlantillaEscritoRequest = this.plantillaForm.value as UpdatePlantillaEscritoRequest;
    updatePlantillaEscritoRequest.id = this.data.entidad.id
    this.plantillaEscritoService.update(updatePlantillaEscritoRequest).subscribe(
      data => {
        this.spinner.hide('spListado')
        this.snackBar.showSuccess('Plantilla actualiza.', "Exito");
        this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.entidad });
      },
      error => {
        this.spinner.hide('spListado')
        this.snackBar.showError(error, "Error");
      }
    );
  }
  clonar(id: number) {
    this.plantillaEscritoService.clone(id).subscribe(
      data => {
        this.spinner.hide('spListado')

      },
      error => {
        this.spinner.hide('spListado')
        this.snackBar.showError(error, "Error");
      }
    );
  }

  duplicar(plantilla: PlantillaEscritoDto) {
    this.clonar(plantilla.id)
    // const nueva = { ...plantilla, titulo: plantilla.titulo + ' (copia)', id: undefined };
    // this.plantillaService.create(nueva).subscribe(() => {
    //   this.snackBar.open('Plantilla duplicada', '', { duration: 2000 });
    //   this.cargarPlantillas();
    // });
  }

  onEliminar() { }
  eliminar(id: number) {
    this.plantillaEscritoService.delete(id).subscribe(
      data => {
        this.spinner.hide('spListado')

      },
      error => {
        this.spinner.hide('spListado')
        this.snackBar.showError(error, "Error");
      }
    );
  }

  cancelar() {
    this.idSeleccionado = null;
    this.plantillaForm.reset({ idUsuario: 1 });
  }

  filtrar(): PlantillaEscritoDto[] {
    return this.plantillas.filter(p =>
      (!this.tipoFiltro || p.tipoEscrito.id === this.tipoFiltro) &&
      (!this.filtro || p.titulo.toLowerCase().includes(this.filtro.toLowerCase()))
    );
  }

  getAllTipoEscrito() {
    this.spinner.show('spBusquedaTiposEscrito')
    this.tipoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spBusquedaTiposEscrito')
          this.tiposEscrito = data
        },
        error => {
          this.spinner.hide('spBusquedaTiposEscrito')
          this.snackBar.showError(error, "Error");
        })
  }

  trackByentidads(index: number, entidad: any): any { return entidad; }
}
